import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { useSelector, useDispatch } from 'react-redux';
import CloseIcon from "@material-ui/icons/Close";

import {
  ModalContent,
  ButtonArea,
  Button,
  CloseIconContainer
} from "./styles";

import { verifyQuarenteneNPS } from '~/utils/utils';
import "~/components/styles/Global.css";
import "~/components/styles/Contracts.css";
import api from '~/services/api';

export default function NpsRelational({
}) {
  const dispatch = useDispatch();
  const npsReducer = useSelector(state => state.npsReducer);
  const [modalOpen, setModalOpen] = useState(npsReducer.open);
  const [searchNps, setSearchNps] = useState(npsReducer.url);
  const [loadVisualizedNps, setLoadVisualizedNps] = useState(true);

  function formatDate() {
    var date = new Date()
    date.setDate(date.getDate() - 2);

    const month = `${date.getMonth() + 1 >= 10 ? '' : '0'}` + (date.getMonth() + 1);
    const day = `${date.getDate() >= 10 ? '' : '0'}` + date.getDate();
    const year = date.getFullYear();

    return [year, month, day].join('-');
  }

  function getExternalLoadId() {
    const externalLoadId = localStorage.getItem('external_load_id');
    const storeId = localStorage.getItem('storeId');
    if (externalLoadId) {
      return externalLoadId;
    }
    return storeId;
  }

  function hasAceptedTermsLGPDNps() {
    const privacyPolicy = localStorage.getItem('privacyPolicyFirst');
    const lgpd = localStorage.getItem('lgpd');
    if (privacyPolicy === 'true' && lgpd === 'true') {
      return true;
    }
    return false;
  }

  function hasTrainingComplicance() {
    const competitiveCompliance = localStorage.getItem('competitiveCompliance');
    if (hasAceptedTermsLGPDNps() && competitiveCompliance === 'true' ) {
      return true;
    }
    return false
  }

  function handleModalNpsRelational() {
    if (hasTrainingComplicance()) {
      return true;
    }
    return false;
  }

  async function createVisualizedByUserId() {
    if (loadVisualizedNps){
      const header = {
        'Content-Type': 'application/json',
        access_token: localStorage.getItem('access_token')
      };
      const parameters = {
        method: 'POST',
        headers: header,
      };

      const url = `/residential/store/v1/users/${localStorage.getItem("userId")}/visualized-nps`;
      await api
        .post(url, {}, parameters)
        .then(res => {
          setLoadVisualizedNps(false);
        })
        .catch(function(error) {
          console.warn("Erro created visualized nps", error)
          dispatch({ type: 'SET_OPEN', open: false, openNpsScript: true });
          setLoadVisualizedNps(false);
        });
    }
  }

  async function hasSearchNPSInIndeCx() {
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };
    const parameters = {
      method: 'GET',
      headers: header,
    };

    const url = `/customer-relationship/nps/v1/researches?store-id=${getExternalLoadId()}&limit=100&page=1`;
    await api
      .get(url, parameters)
      .then(res => {
        const invites = res.data.invites;

        if (!invites.length) {
          dispatch({ type: 'SET_OPEN', open: false, openNpsScript: true });
        }

        for (var i=0; i < invites.length; i+=1) {
          if (invites[i].active && !invites[i].answered) {
            const indicator = invites[i].indicators.find((item) => item.value === getExternalLoadId());
            if (indicator) {
              setSearchNps(invites[i].shortUrl);
              dispatch({ type: 'SET_URL', url: invites[i].shortUrl});
              setModalOpen(true);
              createVisualizedByUserId();
            }
          }
        }
      })
      .catch(function(error) {
        console.warn("Erro searching indeCx nps", error)
        dispatch({ type: 'SET_OPEN', open: false, openNpsScript: true });
      })
  }

  async function getVisualizedByUserId() {
    if (loadVisualizedNps){
      const header = {
        'Content-Type': 'application/json',
        access_token: localStorage.getItem('access_token')
      };
      const parameters = {
        method: 'GEt',
        headers: header,
      };

      const url = `/residential/store/v1/users/${localStorage.getItem("userId")}/nps`;
      await api
        .get(url, parameters)
        .then(res => {
          if (verifyQuarenteneNPS(res.data.visualizedNpsRelational)) {
            hasSearchNPSInIndeCx();
          } else {
            dispatch({ type: 'SET_OPEN', open: false, openNpsScript: true });
          }
          setLoadVisualizedNps(false);
        })
        .catch(function(error) {
          console.warn("Erro searching visualized nps", error)
          hasSearchNPSInIndeCx();
          createVisualizedByUserId();
          dispatch({ type: 'SET_OPEN', open: false, openNpsScript: true });
          setLoadVisualizedNps(false);
        });
    }
  }

  useEffect(() => {
    dispatch({ type: 'SET_OPEN', open: npsReducer.open, openNpsScript: false });
    const visualizedNpsRelational = localStorage.getItem('VisualizedNpsRelational', true)
    if (handleModalNpsRelational() && visualizedNpsRelational !== "true") {
      getVisualizedByUserId();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [npsReducer.open]);

  function handleHideModal() {
    setModalOpen(false);
    dispatch({ type: 'SET_OPEN', open: false, openNpsScript: true });
    dispatch({ type: 'SET_VISUALIZED', visualized: true });
    localStorage.setItem('VisualizedNpsRelational', true)
  }

  return (
    <Modal
      show={modalOpen}
      onHide={() => {
        handleHideModal()
      }}
      className="modal-nps"
      centered={true}
      scrollable={false}
      size="sm"
    >
      <CloseIconContainer>
        <CloseIcon onClick={() => handleHideModal()} />
      </CloseIconContainer>
      <Modal.Body scrollable={false} style={{
        overflow: "hidden",
        padding: ".5rem",
      }}>
          <ModalContent>
            <p style={{fontSize: 18, color: '#00e2ff'}}>
              Gostaríamos de entender sua
            </p>
            <p style={{fontSize: 18}}>
              <b style={{fontSize: 18, color: '#00feff'}}>experiência como parceiro de negócios da Ultragaz.</b>
            </p>
            <p style={{fontSize: 15, marginTop: '1rem', color: 'white'}}>
              É simples e rápido!
            </p>
            <ButtonArea>
              <Button
                onClick={() => {
                  window.open(`${searchNps}-L`, '_blank').focus();
                  setModalOpen(false);
                  dispatch({ type: 'SET_OPEN', open: false, openNpsScript: true });
                  dispatch({ type: 'SET_VISUALIZED', visualized: true });
                  localStorage.setItem('VisualizedNpsRelational', true)
                }}
                target="_blank"
              >
                Quero participar
              </Button>
            </ButtonArea>
          </ModalContent>
      </Modal.Body>
    </Modal>
  );
}
